import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './modules/material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './routes/home/home.component';
import { EsqueciComponent } from './routes/esqueci/esqueci.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RecuperaComponent } from './routes/recupera/recupera.component';
import { LoginCelularComponent } from './routes/login-celular/login-celular.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    EsqueciComponent,
    RecuperaComponent,
    LoginCelularComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
